// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewCurrencyDetails_scrollable-content__zt8vK","card":"ViewCurrencyDetails_card__Fkqw0","ant-card-head-title":"ViewCurrencyDetails_ant-card-head-title__hG6qR"};